import script from "./PrimeFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimeFormModal.vue?vue&type=script&setup=true&lang=js"

import "./PrimeFormModal.vue?vue&type=style&index=0&id=42a690c8&lang=scss"

const __exports__ = script;

export default __exports__